<template>
  <select
    v-bind="$attrs"
    :value="modelValue"
    :class="cn(
      'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm',
      'focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent',
      'disabled:cursor-not-allowed disabled:opacity-50 transition-colors',
      'appearance-none pr-8 bg-no-repeat',
      props.class
    )"
    :style="selectStyle"
    @change="onChange"
  >
    <slot />
  </select>
</template>

<script setup>
import { cn } from '@/lib/utils'

defineOptions({ inheritAttrs: false })

const selectStyle = {
  backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")",
  backgroundPosition: 'right 8px center',
}

const props = defineProps({
  modelValue: { type: [String, Number, Boolean, null], default: '' },
  class: { type: String, default: '' },
})
const emit = defineEmits(['update:modelValue'])

// Like Vue's native v-model on <select>: emit the option's bound value (number, null, …)
// rather than the DOM string. An option bound with :value="null" has no value
// attribute, so the DOM value would otherwise fall back to the option's label.
function onChange(event) {
  const option = event.target.selectedOptions[0]
  emit('update:modelValue', option && '_value' in option ? option._value : event.target.value)
}
</script>
